<app-advanced-form
    [config]="advancedFormConfig$ | async"
    [mmTestId]="'CHANGE_EMAIL.FORM'"
    (events)="onAdvancedFormEvents($event)"
></app-advanced-form>
